import React from 'react';

import '../styles/text-error.scss';

export default function TextError(props) {
  return <div className="error">{props.children}</div>;
}
